import { createSelector } from 'reselect';

import { AppState } from '../../../../../store/models/app-state';

const getTopicsState = (state: AppState) => state.topics;

export const topicsRequestingSelector = createSelector(getTopicsState, state => state.requesting);
export const topicsListSelector = createSelector(getTopicsState, state => state.topics);
export const topicsDetailSelector = createSelector(getTopicsState, state => state.detail);
